import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfigurationField } from "../../types";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/v2/form";
import { Input } from "@/components/ui/v2/input";

export function TextField({
  field,
  disabled,
  type,
}: {
  field: Extract<ConfigurationField, { type: "text" | "email" }>;
  disabled?: boolean;
  type?: "text" | "email";
}) {
  const { control } = useFormContext();
  const { t } = useTranslation();
  const placeholder = field.placeholder?.startsWith("integrations.")
    ? t(field.placeholder)
    : field.placeholder;
  return (
    <FormField
      control={control}
      name={field.key}
      render={({ field: formField }) => (
        <FormItem>
          <FormLabel>
            {t(field.label)}
            {field.required && <span className="text-destructive ml-1">*</span>}
          </FormLabel>
          <FormControl>
            <Input
              type={type || "text"}
              placeholder={placeholder}
              value={formField.value ?? ""}
              disabled={disabled}
              onChange={formField.onChange}
              onBlur={formField.onBlur}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}
